import type { StageReorderInDto } from 'shared/domain/workflow/types';

export type ReorderOperation = {
  stageId: string;
  afterId?: string;
  beforeId?: string;
};

export function buildReorderPayload(op: ReorderOperation): StageReorderInDto {
  const order: StageReorderInDto['order'] = {};
  if (op.beforeId !== undefined) {
    order.beforeId = op.beforeId;
  }
  if (op.afterId !== undefined) {
    order.afterId = op.afterId;
  }
  return { order };
}

export function planReorderOperations(current: string[], desired: string[]): ReorderOperation[] {
  const working = [...current];
  const operations: ReorderOperation[] = [];

  for (let targetIndex = 0; targetIndex < desired.length; targetIndex++) {
    const desiredStageId = desired[targetIndex];
    const currentIndex = working.indexOf(desiredStageId);

    if (currentIndex === -1) {
      throw new Error(`Stage ${desiredStageId} missing from current order`);
    }

    if (currentIndex === targetIndex) {
      continue;
    }

    working.splice(currentIndex, 1);
    working.splice(targetIndex, 0, desiredStageId);

    if (targetIndex === 0) {
      operations.push({
        stageId: desiredStageId,
        beforeId: working[1],
      });
      continue;
    }

    operations.push({
      stageId: desiredStageId,
      afterId: working[targetIndex - 1],
    });
  }

  return operations;
}
